export default __webpack_public_path__ + "static/media/downloadAppQr.eb50f3ce.png";